"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.replace");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _user = require("@/api/user");
var _chat = require("@/api/chat");
var _common = require("@/api/common");
var _vueVirtualScroller = require("vue-virtual-scroller");
require("vue-virtual-scroller/dist/vue-virtual-scroller.css");
var _emoji = _interopRequireDefault(require("./emoji"));
var _videoViewer = _interopRequireDefault(require("@/directive/video-viewer"));
var url = window.location.host;
var _default = exports.default = {
  // name: 'CustomerNimService',
  components: {
    Emoji: _emoji.default,
    RecycleScroller: _vueVirtualScroller.RecycleScroller
  },
  directives: {
    VideoViewer: _videoViewer.default
  },
  props: {
    isShowChat: Boolean
  },
  data: function data() {
    return {
      science: url === process.env.VUE_APP_URL_ADMIN_HOST ? 'overseas' : 'china',
      inputValue: '',
      uploadData: {
        type: 6
      },
      dialogPicVisible: false,
      dialogImgSrc: '',
      pastingFiles: '',
      isCommonWords: false,
      isShowEmoji: false,
      userId: '',
      currentId: '',
      listQuery: {
        classify_id: ''
      },
      classifyList: [],
      actionTypeList: [{
        label: '置顶',
        value: 0,
        key: 'topMessageList'
      }, {
        label: '主播',
        value: 1,
        key: 'anchorMessageList'
      }, {
        label: '充值',
        value: 2,
        key: 'rechargeMessageList'
      }, {
        label: 'VIP',
        value: 3,
        key: 'vipMessageList'
      }, {
        label: '用户',
        value: 4,
        key: 'userMessageList'
      }],
      quickMessageList: [],
      list: [],
      menuVisible: false,
      messageInfo: {},
      customerOnlineDisabled: false,
      customerOnline: false
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    messageNimList: 'messageNimList',
    messageNimActionType: 'messageNimActionType'
  })), (0, _vuex.mapGetters)(['messageNimActionType', 'messageNimList', 'historyMessagesNim', 'remoteNimAccount', 'messageLoading', 'countryCodes'])),
  watch: {
    historyMessagesNim: function historyMessagesNim(val) {
      var _this = this;
      this.$nextTick(function () {
        if (_this.remoteNimAccount) {
          _this.$refs.chatRecordContainer.scrollTop = _this.$refs.chatRecordContainer.scrollHeight;
        }
      });
    },
    messageNimList: function messageNimList(val) {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.buildMessageList();
      });
    },
    messageNimActionType: function messageNimActionType(val) {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.buildMessageList();
      });
    }
  },
  mounted: function mounted() {
    this.getList();
    this.getClassifyList();
    this.buildMessageList();
  },
  methods: {
    buildMessageList: function buildMessageList() {
      var _this4 = this;
      var key = this.actionTypeList.find(function (item) {
        return item.value === _this4.messageNimActionType;
      }).key;
      this.list = key ? this.messageNimList[key] || [] : [];
      console.log('-----', key, this.list);
    },
    getListUnread: function getListUnread(actionType) {
      var key = this.actionTypeList.find(function (item) {
        return item.value === actionType;
      }).key;
      if (!key) return false;
      var index = this.messageNimList[key].findIndex(function (item) {
        return item.unread > 0;
      });
      return index === -1;
    },
    onClearSearch: function onClearSearch() {
      this.$store.dispatch('chatNim/clearSearchList');
    },
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$quickMessageLi, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _chat.quickMessageList)(this.listQuery);
            case 1:
              _yield$quickMessageLi = _context.v;
              code = _yield$quickMessageLi.code;
              data = _yield$quickMessageLi.data;
              if (code === 0) {
                this.quickMessageList = data.list;
                this.customerOnline = data.customerOnline;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    getClassifyList: function () {
      var _getClassifyList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _yield$quickMessageCl, code, data;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _chat.quickMessageClassifyList)({
                page: 1,
                size: 100
              });
            case 1:
              _yield$quickMessageCl = _context2.v;
              code = _yield$quickMessageCl.code;
              data = _yield$quickMessageCl.data;
              if (code === 0) {
                this.classifyList = data.list;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getClassifyList() {
        return _getClassifyList.apply(this, arguments);
      }
      return getClassifyList;
    }(),
    customerOnlineChange: function () {
      var _customerOnlineChange2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(value) {
        var _yield$_customerOnlin, code;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.customerOnlineDisabled = true;
              _context3.n = 1;
              return (0, _chat.customerOnlineChange)({
                customerOnline: value
              });
            case 1:
              _yield$_customerOnlin = _context3.v;
              code = _yield$_customerOnlin.code;
              if (code === 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              }
              this.customerOnlineDisabled = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function customerOnlineChange(_x) {
        return _customerOnlineChange2.apply(this, arguments);
      }
      return customerOnlineChange;
    }(),
    onChangeActionType: function onChangeActionType(type) {
      this.$store.dispatch('chatNim/setActionType', type);
    },
    pasting: function pasting(e) {
      var that = this;
      // 改变this指向
      // 获取剪切板图片
      if (e.clipboardData.files[0]) {
        // 该值可直接上传服务器
        that.pastingFiles = e.clipboardData.files[0];
        // 弹窗显示
        that.dialogPicVisible = true;
        // 看是否支持FileReader
        if (!e || !window.FileReader) return;
        var reader = new FileReader();
        // 在这里转换的
        reader.readAsDataURL(e.clipboardData.files[0]);
        reader.onloadend = function () {
          // 赋值
          that.dialogImgSrc = this.result;
        };
      } else {
        this.inputValue = this.inputValue + e.clipboardData.getData('text');
      }
      // console.log(that.dialogImgSrc)
    },
    // 发送弹框图片 上传服务器
    handleSendImg: function () {
      var _handleSendImg = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var fd, _yield$uploadSendMedi, code, url;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.dialogPicVisible = false;
              fd = new FormData();
              fd.append('file', this.pastingFiles);
              fd.append('type', 6);
              _context4.n = 1;
              return (0, _common.uploadSendMedia)(fd);
            case 1:
              _yield$uploadSendMedi = _context4.v;
              code = _yield$uploadSendMedi.code;
              url = _yield$uploadSendMedi.url;
              if (code === 0) {
                this.$nim.sendImage(this.remoteNimAccount._id, url);
                this.$message({
                  type: 'success',
                  message: '发送图片成功'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: '上传图片失败！'
                });
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleSendImg() {
        return _handleSendImg.apply(this, arguments);
      }
      return handleSendImg;
    }(),
    handleClose: function handleClose() {
      this.dialogPicVisible = false;
    },
    handleKeyCode: function handleKeyCode(event) {
      if (event.keyCode === 13) {
        if (!event.metaKey) {
          event.preventDefault();
          this.send();
        } else {
          this.messageTxt = this.messageTxt + '\n';
        }
      }
    },
    send: function send() {
      if (this.inputValue.trim() === '') return false;
      this.$nim.sendText(this.remoteNimAccount._id, this.inputValue.trim().replace(/<br>/g, '\r\n'), this.remoteNimAccount);
      this.inputValue = '';
    },
    hide: function hide() {
      this.$emit('update:visible', false);
      this.$store.dispatch('chatNim/setRemoteAccount', null);
    },
    openUser: function openUser(info) {
      this.currentId = info.targetUserInfo._id;
      this.$store.dispatch('chatNim/setRemoteAccount', info.targetUserInfo);
      this.messageInfo = info;
      this.$nim.getHistoryMsgsDone(info.targetUserInfo._id);
      this.$nim.setCurrSession(info.targetUserInfo._id);
    },
    launch: function () {
      var _launch = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var _yield$getUserByIds, code, data, userInfo, info;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return (0, _user.getUserByIds)({
                ids: this.userId.toString(),
                type: 0
              });
            case 1:
              _yield$getUserByIds = _context5.v;
              code = _yield$getUserByIds.code;
              data = _yield$getUserByIds.data;
              if (code === 0) {
                if (data.list.length === 0) {
                  this.$message({
                    message: this.$t('tips.userNotexist'),
                    type: 'warning'
                  });
                } else {
                  userInfo = data.list[0];
                  info = {
                    id: 'p2p-' + this.userId,
                    scene: 'p2p',
                    updateTime: new Date().getTime(),
                    unread: 0,
                    to: this.userId + '',
                    targetUserInfo: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, userInfo), {}, {
                      _id: this.userId,
                      time: '2019-11-27'
                    })
                  };
                  this.$store.dispatch('chatNim/addMessageList', info);
                  this.$nim.getHistoryMsgsDone(info);
                }
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function launch() {
        return _launch.apply(this, arguments);
      }
      return launch;
    }(),
    handleAvatarSuccess: function () {
      var _handleAvatarSuccess = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(res, file) {
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              // const base64Str = (await compressImage(file.raw)).substring(23)
              this.$nim.sendImage(this.remoteNimAccount._id, res.url);
              this.$message({
                type: 'success',
                message: '发送图片成功'
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function handleAvatarSuccess(_x2, _x3) {
        return _handleAvatarSuccess.apply(this, arguments);
      }
      return handleAvatarSuccess;
    }(),
    checkEmoji: function checkEmoji(emoji) {
      this.inputValue += emoji.emoji;
      this.isShowEmoji = !this.isShowEmoji;
    },
    payurl: function payurl() {
      this.inputValue = 'https://videochat.officialstore.vip?channelGroup=fromCustomer&type=0&userId=' + this.remoteNimAccount._id;
    },
    vipurl: function vipurl() {
      this.inputValue = 'https://videochat.officialstore.vip?channelGroup=fromCustomer&type=1&userId=' + this.remoteNimAccount._id;
    },
    cashbackUrl: function cashbackUrl() {
      this.inputValue = 'https://activity.kkstar.link/web/#/cashback/index?userId=' + this.remoteNimAccount._id;
    },
    handleCommand: function handleCommand(command) {
      this.inputValue = command;
    },
    // 右键点击
    rightClick: function rightClick(MouseEvent, messageInfo) {
      // 鼠标右击触发事件
      this.messageInfo = messageInfo;
      this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
      this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
      var menu = document.querySelector('#menu');
      menu.style.display = 'block';
      menu.style.left = MouseEvent.clientX - 0 + 'px';
      menu.style.top = MouseEvent.clientY - 0 + 'px';
      document.addEventListener('click', this.foo); // 给整个document添加监听鼠标事件，点击任何位置执行foo方法
    },
    foo: function foo() {
      // 取消鼠标监听事件 菜单栏
      this.menuVisible = false;
      document.removeEventListener('click', this.foo);
    },
    topOperation: function topOperation(messageInfo) {
      this.messageInfo = messageInfo || this.messageInfo;
      // this.$nim.addStickTopSession(this.messageInfo.id)
      if (this.messageInfo.isTop) {
        this.$nim.deleteStickTopSession(this.messageInfo.id);
      } else {
        this.$nim.addStickTopSession(this.messageInfo.id);
      }
    }
  }
};